const CaretDown = ({ up }: { up?: boolean }) => {
  return (
    <svg
      width={10 * 1.5}
      height={6 * 1.5}
      viewBox="0 0 10 6"
      fill="none"
      style={{
        transform: up ? "rotate(180deg)" : "",
        transformOrigin: "center",
        transition: "transform 0.1s",
      }}
    >
      <path
        d="M1.43466 1.35033L4.97021 4.88184L8.50577 1.35033"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CaretDown;
